export const TAG_COLORS = {
    NEGATIVE: '#ef6c00',
    POSITIVE: '#2e7d32',
};
